import axios from "axios"

const baseURL  = process.env.VUE_APP_BACKEND

const api = axios.create({ baseURL })

api.interceptors.request.use( // Configura interceptores de requisição
  ( config ) => {
    const token = localStorage.getItem( "token" ); // token de autenticação
    if ( token && config.url !== "/auth" ) {
      config.headers.Authorization = `Bearer ${ token }`;
    }
    return config;
  },
  ( error ) => {
    throw error; // Lida com erros na requisição
  }
);

api.interceptors.response.use( // Configura interceptores de resposta
  async ( response ) => {
    return response; // Qualquer status code dentro do intervalo de 2xx cai aqui
  },
  async ( error ) => {
    // const originalRequest = error.config;
    const isInvalidTokenError = ( error?.status === 403 || error?.status === 401 ) && error?.response?.data?.message?.includes( "Invalid Token!" );
    if ( isInvalidTokenError ) {
      localStorage.removeItem( "token" );
      window.location.href = "/login";
      // originalRequest._retry = true; // Evita loops infinitos
      // try {
      //   const invalidToken = localStorage.getItem( "token" );
      //   const refreshResponse = await axios.post(
      //     `${ baseURL }/auth/refresh_token`,
      //     {}, // Corpo vazio
      //     {
      //       headers: {
      //         Authorization: `Bearer ${ invalidToken }`,
      //       },
      //     }
      //   );

      //   const newToken = refreshResponse.data.token;

      //   localStorage.setItem( "token", newToken ); // Armazena o novo token no localStorage
        
      //   originalRequest.headers.Authorization = `Bearer ${ newToken }`; // Atualiza o cabeçalho da requisição original com o novo token

      //   return api( originalRequest ); // Refaz a requisição original com o novo token
      // } catch ( refreshError ) {
      //   console.error( "Erro ao tentar renovar o token:", refreshError );

      //   window.location.href = "/login"; // Caso a renovação do token falhe, você pode redirecionar o usuário para login, por exemplo:

      //   throw refreshError;
      // }
    }

    const errorData = error?.response?.data || error;
    if (errorData && typeof errorData === 'object' && errorData.message) {
      if (Array.isArray(errorData.message)) {
        errorData.message = errorData.message.join(', ');
      }
    }
    throw errorData; // Qualquer status code fora do intervalo de 2xx cai aqui

  }
);

export default api
